<template>
  <div>
    <!-- Alert - DESKTOP-->
    <div v-if="checkAlert && $route.name !== 'Chat'" class="row border-top-danger px-4 py-1 alert-danger shadow-sm mb-2"
         style="margin-left: -25px; margin-right: -25px; border-top: 1px solid rgb(120 38 31 / 20%);">
      <div class="col-12 d-flex justify-content-between pb-2">
        <div class="d-flex align-content-center">
          <i class="bx bx-error-circle mt-1 mr-2"></i>
          <span :style="($mq === 'mobile' || $mq === 'tablet') ? 'font-size: 0.9rem;' : ''">
            <strong>{{ getTranslations('expression_1098') }}:</strong>
            {{ getTranslations('expression_1099') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: "AlertSystemUsage",
  computed: {
    ...mapState(['configs', 'me', 'dashboard']),
    ...mapGetters(['getTranslation']),
    // 200 tickets em atendimento
    checkAlert(){
      if(this.chat.tickets && this.chat.tickets.length > 200){
        return true
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.list-group-item:last-child {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
